import { defineComponent as M, useSlots as h, computed as l, useCssModule as L, openBlock as r, createBlock as f, resolveDynamicComponent as R, normalizeClass as z, unref as t, withCtx as T, createElementBlock as V, Fragment as k, renderSlot as u, createCommentVNode as p } from "vue";
import { VButtonVariants as o, VButtonSizes as i, VButtonTags as C } from "../../../packages/vsimple-ui/types/VButton.mjs";
import E from "../VSpinner/VSpinner.vue.mjs";
import { VSpinnerSizes as s, VSpinnerVariants as v } from "../../../packages/vsimple-ui/types/VSpinner.mjs";
const X = /* @__PURE__ */ M({
  __name: "VButton",
  props: {
    variant: { default: o.PRIMARY },
    size: { default: i.MEDIUM },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    tag: { default: C.BUTTON },
    rel: { default: null },
    active: { type: Boolean, default: !1 },
    fixedWidth: { type: Boolean, default: !0 },
    href: { default: null },
    target: { default: null },
    type: { default: null },
    fill: { type: Boolean, default: !1 },
    iconRight: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    dataTest: {}
  },
  emits: ["click"],
  setup(m, { emit: y }) {
    const a = m, c = y, S = h(), g = l(() => a.size === i.EXTRA_EXTRA_SMALL ? s.EXTRA_SMALL : a.size === i.EXTRA_SMALL ? s.SMALL : a.size === i.SMALL ? s.SMALL : s.MEDIUM), B = l(() => [o.ACTION, o.ICON, o.GHOST].includes(a.variant) ? v.PRIMARY : v.SECONDARY), b = l(() => !!S.icon), A = l(() => a.loading || a.disabled), n = L();
    return (e, d) => (r(), f(R(e.tag), {
      class: z([
        t(n)["v-button"],
        t(n)[`v-button--${e.variant}`],
        t(n)[`v-button--${e.size}`],
        t(n)[`v-button--${e.type}`],
        {
          [t(n)["v-button--has-icon"]]: !e.loading && b.value,
          [t(n)["v-button--icon-only"]]: e.iconOnly,
          [t(n)["v-button--fill"]]: e.fill,
          [t(n)["v-button--active"]]: e.active,
          [t(n)["v-button--not-fixed-width"]]: !e.fixedWidth
        }
      ]),
      rel: e.rel,
      href: e.href,
      type: e.type || "button",
      target: e.target,
      disabled: A.value || null,
      "data-test": e.dataTest,
      "aria-label": "Button",
      onClick: d[0] || (d[0] = (I) => c("click"))
    }, {
      default: T(() => [
        e.loading ? (r(), f(t(E), {
          key: 0,
          size: g.value,
          variant: B.value
        }, null, 8, ["size", "variant"])) : (r(), V(k, { key: 1 }, [
          e.iconRight ? p("", !0) : u(e.$slots, "icon", { key: 0 }),
          u(e.$slots, "default"),
          e.iconRight ? u(e.$slots, "icon", { key: 1 }) : p("", !0)
        ], 64))
      ]),
      _: 3
    }, 8, ["class", "rel", "href", "type", "target", "disabled", "data-test"]));
  }
});
export {
  X as default
};
